"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validatePaymentMethods = exports.supportedPaymentMethods = exports.supportedPaymentGateways = exports.standardPaymentMethods = exports.shouldShowGatewayComponent = exports.readablePaymentMethodNames = exports.logos = exports.getStandardCopy = exports.getAvailablePaymentMethods = exports.default = exports.bankPaymentMethodsMapper = exports.bankPaymentMethods = exports.STANDARD_PAYMENT_METHODS = exports.BANK_PAYMENT_METHODS = void 0;
var _react = _interopRequireDefault(require("react"));
var _i18next = _interopRequireDefault(require("i18next"));
var _store = _interopRequireDefault(require("../redux/store"));
var _planHelper = require("./planHelper");
var _formatNumber = _interopRequireDefault(require("./formatNumber"));
var _jsxRuntime = require("react/jsx-runtime");
var CardLogo = function CardLogo(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M0 19.893a2.388 2.388 0 0 0 2.387 2.387h23.872a2.388 2.388 0 0 0 2.387-2.387V11.14H0Zm9.549-3.382a.6.6 0 0 1 .6-.6h6.764a.6.6 0 0 1 .6.6V18.5a.6.6 0 0 1-.6.6h-6.768a.6.6 0 0 1-.6-.6Zm-6.366 0a.6.6 0 0 1 .6-.6H7.36a.6.6 0 0 1 .6.6V18.5a.6.6 0 0 1-.6.6H3.78a.6.6 0 0 1-.6-.6ZM28.646 2.387v2.387H0V2.387A2.388 2.388 0 0 1 2.387 0h23.872a2.388 2.388 0 0 1 2.387 2.387Z",
      fill: "#bcc3cd"
    })
  });
};
CardLogo.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28.646 22.28"
};
var PaypalLogo = function PaypalLogo(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        style: {
          fill: "none"
        },
        d: "M0 0h25.576v30.177H0z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
        id: "a",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M0 0h25.576v30.177H0z"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        clipPath: "url(#a)",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "m7.266 29.154.523-3.322-1.165-.027H1.061L4.927 1.292a.316.316 0 0 1 .314-.268h9.38c3.114 0 5.263.648 6.385 1.927.526.6.861 1.227 1.023 1.917.17.724.173 1.589.007 2.644l-.012.077v.676l.526.298a3.69 3.69 0 0 1 1.065.812c.45.513.741 1.165.864 1.938.127.795.085 1.741-.123 2.812-.24 1.232-.628 2.305-1.152 3.183a6.547 6.547 0 0 1-1.825 2c-.696.494-1.523.869-2.458 1.109-.906.236-1.939.355-3.072.355h-.73c-.522 0-1.029.188-1.427.525a2.21 2.21 0 0 0-.744 1.328l-.055.299-.924 5.855-.042.215c-.011.068-.03.102-.058.125a.155.155 0 0 1-.096.035H7.266Z",
          style: {
            fill: "#253b80",
            fillRule: "nonzero"
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M23.048 7.667c-.028.179-.06.362-.096.55-1.237 6.351-5.469 8.545-10.874 8.545H9.326c-.661 0-1.218.48-1.321 1.132L6.596 26.83l-.399 2.533a.704.704 0 0 0 .695.814h4.881c.578 0 1.069-.42 1.16-.99l.048-.248.919-5.832.059-.32c.09-.572.582-.992 1.16-.992h.73c4.729 0 8.431-1.92 9.513-7.476.452-2.321.218-4.259-.978-5.622a4.667 4.667 0 0 0-1.336-1.03Z",
          style: {
            fill: "#179bd7",
            fillRule: "nonzero"
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M21.754 7.151a9.757 9.757 0 0 0-1.203-.267 15.284 15.284 0 0 0-2.426-.177h-7.352a1.172 1.172 0 0 0-1.159.992L8.05 17.605l-.045.289a1.336 1.336 0 0 1 1.321-1.132h2.752c5.405 0 9.637-2.195 10.874-8.545.037-.188.068-.371.096-.55a6.594 6.594 0 0 0-1.017-.429 9.045 9.045 0 0 0-.277-.087Z",
          style: {
            fill: "#222d65",
            fillRule: "nonzero"
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M9.614 7.699a1.169 1.169 0 0 1 1.159-.991h7.352c.871 0 1.684.057 2.426.177a9.757 9.757 0 0 1 1.481.353c.365.121.704.264 1.017.429.368-2.347-.003-3.945-1.272-5.392C20.378.682 17.853 0 14.622 0h-9.38c-.66 0-1.223.48-1.325 1.133L.01 25.898a.806.806 0 0 0 .795.932h5.791l1.454-9.225 1.564-9.906Z",
          style: {
            fill: "#253b80",
            fillRule: "nonzero"
          }
        })]
      })]
    })
  });
};
PaypalLogo.defaultProps = {
  viewBox: "0 0 26 31",
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve"
};
var ApplePayLogo = function ApplePayLogo(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      style: {
        isolation: "isolate"
      },
      fill: "#bcc3cd",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "m39.031 19.574-.286-.067v-1.7h.55a1.776 1.776 0 0 0 1.94-1.33 1.993 1.993 0 0 0 .016-1.529c-1.181-3.175-2.317-6.367-3.467-9.554-.033-.093-.061-.188-.1-.306.759 0 1.5 0 2.231.009.061 0 .149.116.174.193.429 1.368.851 2.739 1.274 4.11s.838 2.711 1.258 4.066c.018.059.04.117.085.248.048-.14.078-.219.1-.3q1.256-4.054 2.509-8.109c.047-.152.1-.225.282-.222.675.013 1.35.005 2.054.005a1.762 1.762 0 0 1-.043.183q-2 5.618-4.013 11.236a6.341 6.341 0 0 1-1 1.859 3.174 3.174 0 0 1-2.229 1.162c-.075.008-.149.029-.224.045Z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M9.531 0a3.426 3.426 0 0 1-2.41 3.554 6.35 6.35 0 0 1-.737.105 2.5 2.5 0 0 1 .142-1.272A3.529 3.529 0 0 1 9.194.043a.658.658 0 0 0 .1-.043Z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M12.396 5.364a3.518 3.518 0 0 0 .433 6.231c-.177.409-.338.827-.535 1.227a9.013 9.013 0 0 1-1.437 2.11 2.06 2.06 0 0 1-2.608.558 3.254 3.254 0 0 0-2.029-.339 7.95 7.95 0 0 0-1.057.345 2.538 2.538 0 0 1-1.266.233 2.054 2.054 0 0 1-1.2-.67 9.773 9.773 0 0 1-2.395-4.331 7.133 7.133 0 0 1-.086-3.795 4.007 4.007 0 0 1 2.43-2.816 3.2 3.2 0 0 1 2.364-.052c.291.107.583.211.869.332a1.559 1.559 0 0 0 1.22.008 9.333 9.333 0 0 1 1.5-.5 3.611 3.611 0 0 1 3.581 1.164c.052.057.1.121.144.183.022.03.041.063.072.112Z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M17.013 1.122c.079 0 .141-.009.2-.009 1.77 0 3.541-.009 5.311 0a4.561 4.561 0 0 1 3.579 1.551 4.722 4.722 0 0 1 1.116 3.342 4.588 4.588 0 0 1-1.508 3.461 4.8 4.8 0 0 1-3.225 1.19c-.97.019-1.941.006-2.911.007h-.312v4.941h-2.25Zm2.262 1.9v5.744h2.483c.186 0 .374 0 .558-.018a3.061 3.061 0 0 0 1.6-.566 2.689 2.689 0 0 0 1-2.277 2.561 2.561 0 0 0-1.951-2.758 3.458 3.458 0 0 0-.8-.12c-.916-.018-1.833-.014-2.749-.018a1.42 1.42 0 0 0-.138.014Z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M36.798 15.61h-2.076v-1.688l-.087-.057a.252.252 0 0 1-.013.1 4.076 4.076 0 0 1-5.783.966 2.914 2.914 0 0 1 .538-4.849 6.933 6.933 0 0 1 2.6-.572c.829-.05 1.659-.094 2.488-.15.06 0 .165-.084.164-.127a7.5 7.5 0 0 0-.053-1.16 1.494 1.494 0 0 0-1.126-1.211 3.037 3.037 0 0 0-1.543-.08 1.839 1.839 0 0 0-1.56 1.412h-2.02A2.759 2.759 0 0 1 28.7 6.86a3.622 3.622 0 0 1 2.283-1.682 5.54 5.54 0 0 1 3.954.28 3.051 3.051 0 0 1 1.862 2.928c.01 2.346 0 4.691 0 7.037Zm-2.195-4.729a.535.535 0 0 0-.089-.009c-.751.047-1.5.092-2.253.142a3.907 3.907 0 0 0-1.448.3 1.339 1.339 0 0 0 .028 2.483 2.722 2.722 0 0 0 1.5.188 2.463 2.463 0 0 0 2.262-3.104Z"
      })]
    })
  });
};
ApplePayLogo.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 47.654 19.573"
};
var GooglePayLogo = function GooglePayLogo(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      className: "st0",
      d: "M37.8 19.7V29h-3V6h7.8c1.9 0 3.7.7 5.1 2 1.4 1.2 2.1 3 2.1 4.9 0 1.9-.7 3.6-2.1 4.9-1.4 1.3-3.1 2-5.1 2l-4.8-.1zm0-10.9v8h5c1.1 0 2.2-.4 2.9-1.2 1.6-1.5 1.6-4 .1-5.5l-.1-.1c-.8-.8-1.8-1.3-2.9-1.2h-5zM56.7 12.8c2.2 0 3.9.6 5.2 1.8s1.9 2.8 1.9 4.8V29H61v-2.2h-.1c-1.2 1.8-2.9 2.7-4.9 2.7-1.7 0-3.2-.5-4.4-1.5-1.1-1-1.8-2.4-1.8-3.9 0-1.6.6-2.9 1.8-3.9 1.2-1 2.9-1.4 4.9-1.4 1.8 0 3.2.3 4.3 1v-.7c0-1-.4-2-1.2-2.6-.8-.7-1.8-1.1-2.9-1.1-1.7 0-3 .7-3.9 2.1l-2.6-1.6c1.6-2.1 3.7-3.1 6.5-3.1zm-3.8 11.4c0 .8.4 1.5 1 1.9.7.5 1.5.8 2.3.8 1.2 0 2.4-.5 3.3-1.4 1-.9 1.5-2 1.5-3.2-.9-.7-2.2-1.1-3.9-1.1-1.2 0-2.2.3-3 .9-.8.5-1.2 1.2-1.2 2.1zM80 13.3 70.1 36h-3l3.7-7.9-6.5-14.7h3.2l4.7 11.3h.1l4.6-11.3H80z",
      fill: "#5F6368"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      className: "st1",
      d: "M25.9 17.7c0-.9-.1-1.8-.2-2.7H13.2v5.1h7.1c-.3 1.6-1.2 3.1-2.6 4v3.3H22c2.5-2.3 3.9-5.7 3.9-9.7z",
      fill: "#4285F4"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      className: "st2",
      d: "M13.2 30.6c3.6 0 6.6-1.2 8.8-3.2l-4.3-3.3c-1.2.8-2.7 1.3-4.5 1.3-3.4 0-6.4-2.3-7.4-5.5H1.4v3.4c2.3 4.5 6.8 7.3 11.8 7.3z",
      fill: "#34A853"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      className: "st3",
      d: "M5.8 19.9c-.6-1.6-.6-3.4 0-5.1v-3.4H1.4c-1.9 3.7-1.9 8.1 0 11.9l4.4-3.4z",
      fill: "#FBBC04"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      className: "st4",
      d: "M13.2 9.4c1.9 0 3.7.7 5.1 2l3.8-3.8c-2.4-2.2-5.6-3.5-8.8-3.4-5 0-9.6 2.8-11.8 7.3l4.4 3.4c.9-3.2 3.9-5.5 7.3-5.5z",
      fill: "#EA4335"
    })]
  });
};
GooglePayLogo.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 80 38.1"
};
var IdealLogo = function IdealLogo(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M.39 1.935v15.363c0 .735.624 1.337 1.387 1.337h9.518c7.195 0 10.315-3.884 10.315-9.038 0-5.128-3.12-8.999-10.315-8.999H1.777C1.014.598.39 1.2.39 1.935Z",
      fill: "#fff"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M6.76 4.369V15.72h5.124c4.651 0 6.669-2.533 6.669-6.117 0-3.43-2.018-6.09-6.67-6.09H7.649c-.492 0-.887.388-.887.856Z",
      fill: "#C06"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M11.295 17.412H3.017c-.734 0-1.33-.575-1.33-1.284V3.112c0-.709.596-1.284 1.33-1.284h8.278c7.854 0 9.025 4.874 9.025 7.775 0 5.034-3.21 7.809-9.025 7.809ZM3.017 2.256c-.492 0-.887.381-.887.856v13.016c0 .475.395.856.887.856h8.278c5.531 0 8.582-2.62 8.582-7.38 0-6.392-5.38-7.348-8.582-7.348H3.017Z",
      fill: "#000"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M8.563 8.072c.18 0 .347.027.506.08.16.054.291.141.41.248.11.114.2.254.27.414.062.168.097.361.097.589 0 .2-.028.38-.077.548a1.265 1.265 0 0 1-.235.434c-.104.12-.236.214-.395.288-.16.067-.347.107-.562.107H7.364V8.066h1.2v.006Zm-.041 2.213c.09 0 .173-.013.263-.04a.52.52 0 0 0 .222-.14.775.775 0 0 0 .16-.254c.041-.107.062-.228.062-.381 0-.134-.014-.261-.042-.368a.72.72 0 0 0-.138-.28.623.623 0 0 0-.25-.181 1.055 1.055 0 0 0-.381-.06h-.444v1.71h.548v-.006ZM12.348 8.072v.502h-1.483v.581h1.365v.462h-1.365v.661h1.518v.502h-2.135V8.066h2.1v.006ZM14.47 8.072l1.053 2.715h-.644l-.215-.602H13.61l-.222.602h-.624l1.06-2.715h.646Zm.034 1.665-.353-.996h-.007l-.368.996h.728ZM16.528 8.072v2.213h1.373v.502h-1.99V8.072h.617Z",
      fill: "#fff"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M4.446 10.68c.715 0 1.296-.56 1.296-1.25 0-.691-.58-1.25-1.296-1.25-.716 0-1.297.559-1.297 1.25 0 .69.58 1.25 1.296 1.25ZM5.423 15.72c-1.088 0-1.962-.849-1.962-1.892v-1.477c0-.522.437-.95.985-.95.54 0 .984.422.984.95v3.37h-.007Z",
      fill: "#000"
    })]
  });
};
IdealLogo.defaultProps = {
  width: "22",
  height: "19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var SofortLogo = function SofortLogo(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.83 8.662H.57L2.055 0h22.26l-1.483 8.662Z",
      fill: "#2E3235"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.67 5.046c-.38 0-.647-.243-.647-.621a.81.81 0 0 1 .809-.813c.38 0 .647.254.647.632a.8.8 0 0 1-.809.802Zm.223-2.159c-1 0-1.755.717-1.755 1.574 0 .776.622 1.314 1.471 1.314 1 0 1.755-.74 1.755-1.597 0-.776-.622-1.29-1.471-1.29ZM13.69 5.046c-.381 0-.647-.243-.647-.621a.81.81 0 0 1 .808-.813c.38 0 .647.254.647.632a.8.8 0 0 1-.809.802Zm.222-2.159c-1 0-1.755.717-1.755 1.574 0 .776.622 1.314 1.471 1.314 1 0 1.756-.74 1.756-1.597 0-.776-.623-1.29-1.472-1.29ZM16.9 4.255h-.13l.098-.578h.119c.277 0 .423.081.423.259 0 .211-.208.319-.51.319Zm1.423-.456c0-.519-.416-.853-1.165-.853h-1.06l-.464 2.77h.892l.146-.872h.041l.473.871h1.023l-.656-.967c.48-.163.77-.515.77-.949ZM5.115 4.051c-.338-.167-.415-.211-.415-.3 0-.111.134-.167.322-.167.215 0 .54.023.858.32.08-.238.208-.454.376-.64-.452-.247-.867-.377-1.25-.377-.762 0-1.198.397-1.198.875 0 .411.317.626.696.815.339.17.424.223.424.327 0 .11-.142.174-.33.174-.326 0-.705-.2-.93-.404l-.13.77c.233.164.567.33 1.072.33.787 0 1.21-.385 1.21-.882 0-.404-.273-.626-.705-.841ZM11.712 4.162h-1.045l.082-.485h1.12c.145-.292.37-.542.65-.73h-1.833c-.407 0-.753.27-.814.635l-.358 2.133h.893l.146-.87h1.06l.076-.474c.004-.071.011-.14.023-.209ZM18.342 2.946c.238.179.385.428.417.73h.746l-.343 2.04h.893l.342-2.04h.827l.122-.73h-3.004Z",
      fill: "#E5E5E0"
    })]
  });
};
SofortLogo.defaultProps = {
  width: "25",
  height: "9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var BancontactLogo = function BancontactLogo(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M.82 14.934v-3.428h1.017c.739 0 1.214.29 1.214.887 0 .337-.15.573-.362.71.306.147.484.43.484.818 0 .69-.484 1.013-1.237 1.013H.82Zm.655-2.003h.484c.297 0 .424-.151.424-.43 0-.3-.23-.397-.541-.397h-.367v.827Zm0 1.406h.404c.396 0 .626-.103.626-.426 0-.319-.197-.45-.57-.45h-.46v.876Zm2.967.656c-.645 0-.97-.328-.97-.769 0-.485.381-.769.946-.774.14.003.28.016.419.04v-.118c0-.299-.165-.44-.48-.44a1.591 1.591 0 0 0-.621.117l-.118-.529a2.25 2.25 0 0 1 .814-.147c.692 0 1.035.382 1.035 1.043v1.362c-.193.102-.555.215-1.025.215Zm.395-.553v-.524a1.516 1.516 0 0 0-.334-.04c-.217 0-.386.089-.386.319 0 .205.141.313.39.313a.712.712 0 0 0 .33-.068Zm1.087.494V12.59a2.774 2.774 0 0 1 1.064-.216c.687 0 1.082.353 1.082 1.004v1.557h-.65v-1.508c0-.338-.15-.495-.437-.495a.953.953 0 0 0-.414.089v1.914h-.645Zm4.415-2.414-.122.534a1.386 1.386 0 0 0-.532-.123c-.381 0-.588.28-.588.74 0 .504.216.764.62.764a1.29 1.29 0 0 0 .523-.128l.104.544a1.53 1.53 0 0 1-.678.142c-.78 0-1.233-.504-1.233-1.303 0-.793.447-1.317 1.195-1.317.244-.001.486.049.71.147Zm1.403 2.473c-.725 0-1.177-.524-1.177-1.312 0-.784.452-1.308 1.177-1.308.729 0 1.171.524 1.171 1.308 0 .788-.442 1.312-1.171 1.312Zm0-.558c.334 0 .508-.29.508-.754 0-.46-.174-.75-.508-.75-.33 0-.513.29-.513.75 0 .465.183.754.513.754Zm1.547.5v-2.347a2.774 2.774 0 0 1 1.063-.215c.687 0 1.082.353 1.082 1.004v1.557h-.649v-1.508c0-.338-.15-.495-.438-.495a.953.953 0 0 0-.413.089v1.914h-.645Zm3.61.058c-.56 0-.847-.318-.847-.965V12.97h-.32v-.538h.32v-.544l.65-.034v.578h.521v.538h-.522v1.048c0 .284.113.417.325.417.084 0 .167-.01.25-.03l.032.544a1.725 1.725 0 0 1-.41.044Zm1.639 0c-.645 0-.97-.328-.97-.769 0-.485.381-.769.946-.774.14.003.28.016.419.04v-.118c0-.299-.165-.44-.48-.44a1.591 1.591 0 0 0-.621.117l-.118-.529a2.25 2.25 0 0 1 .814-.147c.692 0 1.035.382 1.035 1.043v1.362c-.193.102-.555.215-1.025.215Zm.395-.553v-.524a1.517 1.517 0 0 0-.334-.04c-.217 0-.386.089-.386.319 0 .205.141.313.39.313a.712.712 0 0 0 .33-.068Zm2.852-1.92-.123.534a1.387 1.387 0 0 0-.531-.123c-.381 0-.588.28-.588.74 0 .504.216.764.62.764a1.29 1.29 0 0 0 .523-.128l.103.544a1.53 1.53 0 0 1-.677.142c-.781 0-1.233-.504-1.233-1.303 0-.793.447-1.317 1.195-1.317.244-.001.486.049.71.147Zm1.427 2.473c-.56 0-.847-.318-.847-.965V12.97h-.32v-.538h.32v-.544l.65-.034v.578h.522v.538h-.522v1.048c0 .284.113.417.324.417.084 0 .168-.01.25-.03l.033.544a1.725 1.725 0 0 1-.41.044Z",
      fill: "#1E3764"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M5.296 9.897c3.396 0 5.093-2.28 6.791-4.56H.821v4.56h4.475Z",
      fill: "url(#a)"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M19.04.776c-3.477 0-5.215 2.28-6.953 4.56h11.535V.777h-4.583Z",
      fill: "url(#b)"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("defs", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
        id: "a",
        x1: "3.1",
        y1: "7.827",
        x2: "11.356",
        y2: "4.783",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          stopColor: "#005AB9"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "1",
          stopColor: "#1E3764"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
        id: "b",
        x1: "12.786",
        y1: "5.732",
        x2: "21.714",
        y2: "2.636",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          stopColor: "#FBA900"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "1",
          stopColor: "#FFD800"
        })]
      })]
    })]
  });
};
BancontactLogo.defaultProps = {
  width: "24",
  height: "15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var GiftLogo = function GiftLogo(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M27.5 7h-3.27a4.489 4.489 0 0 0-7.98-3.975L15.5 4.03l-.75-1.02A4.49 4.49 0 0 0 6.77 7H3.5a2.977 2.977 0 0 0-2.985 3L.5 26.5a2.99 2.99 0 0 0 3 3h24a2.988 2.988 0 0 0 3-3V10a2.99 2.99 0 0 0-3-3ZM20 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm-9 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm16.5 22.5h-24v-3h24v3Zm0-7.5h-24v-9h7.62L8 14.245 10.43 16 14 11.14l1.5-2.04 1.5 2.04L20.57 16 23 14.245 19.88 10h7.62v9Z",
      fill: "#BCC3CD"
    })
  });
};
GiftLogo.defaultProps = {
  width: "31",
  height: "30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var RokuLogo = function RokuLogo(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("defs", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
        id: "a",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          className: "a",
          d: "M3252.226-5954.029h67.614v-31.789h-67.614Z",
          transform: "translate(-3252.226 5985.818)"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("style", {
        children: [".a", "{", "fill:#662d91", "}"]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      style: {
        clipPath: "url(#a)"
      },
      transform: "translate(-.001)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        className: "a",
        d: "M15.106 12.445a2.788 2.788 0 0 0-2.774-2.8h-1.375v5.575h1.375a2.783 2.783 0 0 0 2.774-2.775m6.257 11.115h-5.049l-4.009-5.563h-1.348v5.551h-4.45V6.871h6.375c3.675 0 6.675 2.5 6.675 5.574a5.417 5.417 0 0 1-2.9 4.575l4.707 6.54"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        className: "a",
        d: "M26.382 13.445c-1.175 0-2.175 1.6-2.175 3.575s1 3.577 2.175 3.577c1.2 0 2.2-1.6 2.2-3.577s-1-3.575-2.2-3.575m6.849 3.575a6.816 6.816 0 0 1-6.849 6.8 6.8 6.8 0 0 1-6.825-6.8 6.8 6.8 0 0 1 6.825-6.8 6.817 6.817 0 0 1 6.849 6.8M43.675 10.496l-5.126 5.125v-5.142h-4.451v13.069h4.449v-5.3l5.352 5.3h5.6l-6.8-6.8 5.633-5.631v7.754c0 2.575 1.549 4.951 5.448 4.951a6.183 6.183 0 0 0 4.376-2l2 1.725h.95V10.496h-4.449v8.45a2.492 2.492 0 0 1-2.278 1.424c-1.095 0-1.6-.649-1.6-2.725v-7.149Z"
      })]
    })]
  });
};
RokuLogo.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "67.614",
  height: "31.789"
};
var AmazonLogo = function AmazonLogo(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M.075 29.773c.12-.193.311-.206.578-.037A38.631 38.631 0 0 0 20.383 35a39.055 39.055 0 0 0 14.04-2.651l.524-.233c.229-.1.389-.166.487-.216a.669.669 0 0 1 .873.216c.2.289.15.558-.2.8-.426.316-1 .681-1.672 1.087a26.982 26.982 0 0 1-6.956 2.869 29.282 29.282 0 0 1-7.506 1.014 29.134 29.134 0 0 1-10.7-1.973 29.718 29.718 0 0 1-9.022-5.571.5.5 0 0 1-.251-.366.362.362 0 0 1 .083-.216Zm10.912-10.335a7.315 7.315 0 0 1 1.235-4.283 7.606 7.606 0 0 1 3.391-2.684 18.385 18.385 0 0 1 4.84-1.2c.648-.076 1.717-.171 3.191-.289v-.615a6.647 6.647 0 0 0-.5-3.117 2.722 2.722 0 0 0-2.394-1.08h-.3a3.992 3.992 0 0 0-2.071.765 3.005 3.005 0 0 0-1.122 1.822.932.932 0 0 1-.723.848l-4.189-.524c-.412-.1-.618-.3-.618-.648a.992.992 0 0 1 .037-.249A6.992 6.992 0 0 1 14.788 3.4a11.626 11.626 0 0 1 5.635-1.745h.9a9.226 9.226 0 0 1 6.46 2.145c.224.249.449.5.673.8a4.309 4.309 0 0 1 .47.748 3.186 3.186 0 0 1 .324.947c.1.422.175.7.224.848A4.789 4.789 0 0 1 29.6 8.16c.017.52.033.819.033.919v8.776a5.42 5.42 0 0 0 .274 1.722 3.963 3.963 0 0 0 .524 1.12l.848 1.12a1.133 1.133 0 0 1 .226.6.64.64 0 0 1-.3.522c-1.995 1.745-3.092 2.693-3.263 2.842a.97.97 0 0 1-1.047.075 10.077 10.077 0 0 1-.874-.824l-.515-.577c-.1-.123-.276-.349-.527-.7l-.5-.723a8.908 8.908 0 0 1-3.986 2.768 10.509 10.509 0 0 1-3.042.377 6.378 6.378 0 0 1-4.588-1.719 6.438 6.438 0 0 1-1.8-4.887l-.083-.126Zm6.238-.728a3.436 3.436 0 0 0 .706 2.267 2.389 2.389 0 0 0 1.92.851 2.449 2.449 0 0 0 .324-.033 1.835 1.835 0 0 1 .276-.038 3.729 3.729 0 0 0 2.367-1.957 5.229 5.229 0 0 0 .6-1.513 6.489 6.489 0 0 0 .224-1.33c.025-.324.025-.9.025-1.67v-.9a12.856 12.856 0 0 0-3.191.3 3.9 3.9 0 0 0-3.191 4.039l-.058-.033Zm15.228 11.68a1.206 1.206 0 0 1 .219-.283 5.923 5.923 0 0 1 1.745-.831 13.453 13.453 0 0 1 2.679-.4 2.21 2.21 0 0 1 .681.05c1.08.1 1.745.279 1.948.549a1.156 1.156 0 0 1 .15.648v.249a8.3 8.3 0 0 1-.69 2.992 7.236 7.236 0 0 1-1.921 2.792.548.548 0 0 1-.327.15.388.388 0 0 1-.15-.02c-.15-.073-.178-.2-.106-.4a13.642 13.642 0 0 0 1.34-4.388.953.953 0 0 0-.145-.572c-.241-.276-.914-.427-2.034-.427-.4 0-.886.027-1.446.076-.6.075-1.164.15-1.662.224a.44.44 0 0 1-.3-.073c-.05-.05-.06-.078-.033-.128a.274.274 0 0 1 .033-.1v-.1Z",
      transform: "translate(-.002 -1.653)",
      style: {
        fill: "#f90"
      }
    })
  });
};
AmazonLogo.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "39.875",
  height: "36.23"
};
var AndroidLogo = function AndroidLogo(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("style", {
        children: [".a", "{", "fill:#62dba3", "}"]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      transform: "translate(0 26.681)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        className: "a",
        d: "M2.854 2.902A2.932 2.932 0 0 0-.004 6.008a2.91 2.91 0 0 0 2.858 3.083 2.3 2.3 0 0 0 1.891-.878v.383a.4.4 0 0 0 .383.383h.945V3.038H4.745v.754a2.3 2.3 0 0 0-1.891-.89Zm.237 1.215a1.818 1.818 0 0 1 1.769 1.89 1.833 1.833 0 0 1-1.766 1.89 1.8 1.8 0 0 1-1.746-1.9 1.771 1.771 0 0 1 1.747-1.88ZM7.919 8.979a.372.372 0 0 1-.383-.383V3.037h1.328v.735a2.071 2.071 0 0 1 1.791-.872 2.219 2.219 0 0 1 2.26 2.275v3.8h-.923a.407.407 0 0 1-.405-.405V5.466a1.26 1.26 0 0 0-1.237-1.349 1.606 1.606 0 0 0-1.486 1.71v3.151ZM16.789 2.902a2.932 2.932 0 0 0-2.858 3.106 2.91 2.91 0 0 0 2.858 3.083 2.3 2.3 0 0 0 1.89-.878v.383a.4.4 0 0 0 .383.383h.945V.067h-1.328v3.725a2.3 2.3 0 0 0-1.89-.89Zm.237 1.215a1.818 1.818 0 0 1 1.769 1.89 1.833 1.833 0 0 1-1.766 1.89 1.8 1.8 0 0 1-1.746-1.9 1.771 1.771 0 0 1 1.742-1.88ZM21.853 8.979a.372.372 0 0 1-.383-.383V3.037h1.328v.99a1.636 1.636 0 0 1 1.6-1.058 2.77 2.77 0 0 1 .473.045v1.374a1.912 1.912 0 0 0-.63-.112 1.57 1.57 0 0 0-1.44 1.709v2.994ZM32.925 8.978a.372.372 0 0 1-.383-.383V3.036h1.328v5.942ZM37.765 2.902a2.932 2.932 0 0 0-2.858 3.106 2.91 2.91 0 0 0 2.858 3.083 2.3 2.3 0 0 0 1.89-.878v.383a.4.4 0 0 0 .383.383h.945V.067h-1.328v3.725a2.3 2.3 0 0 0-1.89-.89Zm.237 1.215a1.818 1.818 0 0 1 1.769 1.89 1.833 1.833 0 0 1-1.766 1.89 1.8 1.8 0 0 1-1.746-1.9 1.771 1.771 0 0 1 1.742-1.88Z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        className: "a",
        cx: ".878",
        cy: ".878",
        r: ".878",
        transform: "translate(32.32)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        className: "a",
        d: "M28.371 2.9a3.058 3.058 0 0 0-3.1 3.1 3.024 3.024 0 0 0 3.094 3.094 3.065 3.065 0 0 0 3.142-3.083A3.085 3.085 0 0 0 28.371 2.9Zm0 1.24a1.793 1.793 0 0 1 1.782 1.861 1.82 1.82 0 0 1-1.779 1.872 1.806 1.806 0 0 1-1.777-1.854 1.79 1.79 0 0 1 1.778-1.879Z"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      className: "a",
      d: "m30.494 6.919 3.4-5.885a.69.69 0 0 0-.25-.941.681.681 0 0 0-.936.25l-3.442 5.961a21.477 21.477 0 0 0-17.522 0L8.294.343a.688.688 0 0 0-1.19.691l3.4 5.885A20.284 20.284 0 0 0 .022 22.965h40.956A20.279 20.279 0 0 0 30.494 6.919Zm-19.4 10.295a1.717 1.717 0 1 1 1.717-1.717 1.717 1.717 0 0 1-1.717 1.717Zm18.8 0a1.717 1.717 0 1 1 1.717-1.717 1.717 1.717 0 0 1-1.711 1.717Z"
    })]
  });
};
AndroidLogo.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40.983 35.773"
};
const supportedPaymentMethods = exports.supportedPaymentMethods = ['card', 'paypal', 'applepay', 'googlepay', 'ideal', 'sofort', 'bancontact_card', 'bancontact_mobile'];
const bankPaymentMethods = exports.bankPaymentMethods = ['ideal', 'sofort',
// Sofort name in cleeng-admin
'directEbanking',
// Sofort name in Adyen
'bancontact_mobile',
// Bancontact Mobile name in cleeng-admin
'bcmc_mobile' // Bancontact Mobile name in Adyen
];
const standardPaymentMethods = exports.standardPaymentMethods = ['card', 'scheme', 'applepay', 'googlepay', 'bancontact_card', 'bcmc'];
const bankPaymentMethodsMapper = exports.bankPaymentMethodsMapper = {
  bcmc_mobile: 'bancontact_mobile',
  directEbanking: 'sofort',
  bcmc: 'bancontact_card'
};
const STANDARD_PAYMENT_METHODS = exports.STANDARD_PAYMENT_METHODS = 'zeroPaymentSupported';
const BANK_PAYMENT_METHODS = exports.BANK_PAYMENT_METHODS = 'zeroPaymentNotSupported';
const readablePaymentMethodNames = exports.readablePaymentMethodNames = {
  card: 'Card',
  paypal: 'PayPal',
  applepay: 'ApplePay',
  googlepay: 'GooglePay',
  ideal: 'iDEAL',
  sofort: 'Sofort',
  bancontact_card: 'Bancontact Card',
  bancontact_mobile: 'Bancontact Mobile'
};
const supportedPaymentGateways = exports.supportedPaymentGateways = ['adyen', 'paypal'];
const logos = exports.logos = {
  card: CardLogo,
  paypal: PaypalLogo,
  applepay: ApplePayLogo,
  apple: ApplePayLogo,
  googlepay: GooglePayLogo,
  ideal: IdealLogo,
  sofort: SofortLogo,
  bancontact_card: BancontactLogo,
  bancontact_mobile: BancontactLogo,
  gift: GiftLogo,
  roku: RokuLogo,
  amazon: AmazonLogo,
  android: AndroidLogo
};
var _default = exports.default = logos;
const validatePaymentMethods = (paymentMethods, arePaymentMethodsProvidedByPublisher) => {
  const {
    publisherConfig: {
      hiddenPaymentMethods
    }
  } = _store.default.getState();
  if (!paymentMethods) return [];
  return paymentMethods.filter(method => {
    const {
      id,
      methodName,
      paymentGateway
    } = method;
    if (hiddenPaymentMethods.includes(id)) {
      return false;
    }
    if (supportedPaymentMethods.includes(methodName) && supportedPaymentGateways.includes(paymentGateway)) {
      return true;
    }
    if (arePaymentMethodsProvidedByPublisher) {
      // eslint-disable-next-line no-console
      console.error("Payment method not supported (id: ".concat(id, ")"));
    }
    return false;
  });
};
exports.validatePaymentMethods = validatePaymentMethods;
const shouldShowGatewayComponent = (gateway, paymentMethods) => !!paymentMethods.find(_ref => {
  let {
    paymentGateway
  } = _ref;
  return paymentGateway === gateway;
});

// returns common part between methods set in admin and those set
// by Config.setVisibleAdyenPaymentMethods()
exports.shouldShowGatewayComponent = shouldShowGatewayComponent;
const getAvailablePaymentMethods = (publisherPaymentMethods, visiblePaymentMethods) => {
  const availablePaymentMethods = visiblePaymentMethods.length ? publisherPaymentMethods.filter(_ref2 => {
    let {
      methodName
    } = _ref2;
    return visiblePaymentMethods.includes(methodName);
  }) : publisherPaymentMethods;
  return availablePaymentMethods;
};
exports.getAvailablePaymentMethods = getAvailablePaymentMethods;
const getStandardCopy = (isMyAccount, offer, order, isGift) => {
  const {
    period: offerPeriod,
    customerPriceExclTax: offerBasePrice
  } = offer;
  const {
    discount,
    currency,
    offerId
  } = order;
  const isSubscription = (offerId === null || offerId === void 0 ? void 0 : offerId.charAt(0)) === 'S';
  const chargedForEveryText = offerPeriod && (0, _planHelper.isPeriod)(offerPeriod) ? _planHelper.periodMapper[offerPeriod].chargedForEveryText : null;
  const readablePrice = "".concat(_planHelper.currencyFormat[currency]).concat((0, _formatNumber.default)(offerBasePrice));
  const readablePeriod = chargedForEveryText ? "/".concat(chargedForEveryText) : '';
  if (isGift) {
    return _i18next.default.t('offer-standard-consent-copy.checkout-not-subscription', 'By ticking this, you agree to the Terms and Conditions of our service.');
  }
  if (isMyAccount) {
    return _i18next.default.t('offer-standard-consent-copy.my-account', 'By ticking this, you agree to the Terms and Conditions of our service. Your account will be charged on a recurring basis for the full subscription amount. Your subscription will continue until you cancel.');
  }
  if (isSubscription) {
    if (discount !== null && discount !== void 0 && discount.applied && discount.type === 'trial') {
      return _i18next.default.t("offer-standard-consent-copy.trial.period-".concat(offerPeriod), "After any free trial and/or promotional period, you will be charged {{readablePrice}}{{readablePeriod}} or the then-current price, plus applicable taxes, on a recurring basis. Your subscription will automatically continue until you cancel. To cancel, log into your account, click 'Manage' next to your subscription and then click 'Cancel'. By checking the box, you expressly acknowledge and agree to these terms as well as the full Terms of Service.", {
        readablePrice,
        readablePeriod
      });
    }
    if (discount !== null && discount !== void 0 && discount.applied && discount.type !== 'trial') {
      return _i18next.default.t("offer-standard-consent-copy.discount.period-".concat(offerPeriod), "After any promotional period, you will be charged {{readablePrice}}{{readablePeriod}} or the then-current price, plus applicable taxes, on a recurring basis. Your subscription will automatically continue until you cancel. To cancel, log into your account, click 'Manage' next to your subscription and then click 'Cancel'. By checking the box, you expressly acknowledge and agree to these terms as well as the full Terms of Service.", {
        readablePrice,
        readablePeriod
      });
    }
    return _i18next.default.t("offer-standard-consent-copy.checkout-subscription.period-".concat(offerPeriod), "You will be charged {{readablePrice}}{{readablePeriod}} or the then-current price, plus applicable taxes, on a recurring basis. Your subscription will automatically continue until you cancel. To cancel, log into your account, click 'Manage' next to your subscription and then click ‘Cancel.’ By checking the box, you expressly acknowledge and agree to these terms as well as the full Terms of Service.", {
      readablePrice,
      readablePeriod
    });
  }
  return _i18next.default.t('offer-standard-consent-copy.checkout-not-subscription', 'By ticking this, you agree to the Terms and Conditions of our service.');
};
exports.getStandardCopy = getStandardCopy;